"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const popupVideoInputs = [
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "light",
  },
  {
    name: "color",
    type: "string",
    defaultValue: "primary",
    enum: ["primary", "secondary", "tertiary", "quaternary"],
  },
  {
    name: "label",
    type: "string",
    defaultValue: "Play Video",
    required: true,
  },
  {
    name: "alignment",
    type: "string",
    defaultValue: "left",
    enum: ["left", "center", "right"],
  },
  {
    name: "videoPlayer",
    type: "uiBlocks",
    defaultValue: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "VideoPlayer",
          options: {
            videoType: "hosted internally",
            hostedVideoConfiguration: {
              desktopSrc:
                "https://cdn.builder.io/o/assets%2F90293f7dc9704cb5935f357315020051%2Fdb83e0ca80d24c6da4c2fb863cd65ebb%2Fcompressed?apiKey=90293f7dc9704cb5935f357315020051&token=db83e0ca80d24c6da4c2fb863cd65ebb&alt=media&optimized=true",
            },
            controlColor: "dark",
            posterAlt: "",
            description: "",
          },
        },
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("videoPlayer");

      if (!Array.isArray(items)) {
        return;
      }

      const onlyVideoPlayer = items.filter((item) => item.component?.name === "VideoPlayer");

      if (onlyVideoPlayer.length > 1) {
        options.set("videoPlayer", onlyVideoPlayer.slice(0, 1));
        alert("You can only add one VideoPlayer component here.");
        return;
      }

      if (onlyVideoPlayer.length < items.length) {
        options.set("videoPlayer", onlyVideoPlayer);
        alert("Only VideoPlayer components are allowed in this slot.");
      }
    },
  },
] as const satisfies Inputs;

export const PopupVideoComponent: RegisteredComponent = {
  name: "PopupVideo",
  component: dynamic(async () =>
    withValidation(popupVideoInputs, (await import("./PopupVideo")).PopupVideo, "PopupVideo")
  ),
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: true,
  inputs: popupVideoInputs,
};
